import { serviceHost } from "../../common/const";
import ServiceRequest from "../../utils/service-request";

export const uploadFile = async (data) => {
  try {
    let response1 = await ServiceRequest(
      "post",
      "multipart/form-data",
      serviceHost + "/kyc/address/uploadFile",
      data
    );
    return { response1, err1: null };
  } catch (err) {
    if (err) {
      return { response1: null, err };
    }
  }
};

export const deleteFile = async (data) => {
  try {
    let response = await ServiceRequest(
      "post",
      "json",
      serviceHost + "/kyc/address/deleteFile",
      data
    );
    return { response, err: null };
  } catch (err) {
    if (err) {
      return { response: null, err };
    }
  }
};

export const deleteFileByFileId = async (fileId) => {
  let data = { fileId: fileId };
  try {
    let response = await ServiceRequest(
      "post",
      "json",
      serviceHost + "/kyc/address/deleteFileByFileId",
      data
    );
    return { response, err: null };
  } catch (err) {
    if (err) {
      return { response: null, err };
    }
  }
};

export const saveFileUpload = async (data) => {
  try {
    let response = await ServiceRequest(
      "post",
      "json",
      serviceHost + "/kyc/address/saveFileUpload",
      data
    );
    return { response, err: null };
  } catch (err) {
    if (err) {
      return { response: null, err };
    }
  }
};

export const downloadFile = async (data) => {
  try {
    let response = await ServiceRequest(
      "post",
      "blob",
      serviceHost + "/kyc/address/downloadFile",
      data
    );
    return { response, err: null };
  } catch (err) {
    if (err) {
      return { response: null, err };
    }
  }
};

export const getAllActiveAddress = async (id, tag) => {
  let data = { Id: id, Tag: tag };
  try {
    let response = await ServiceRequest(
      "post",
      "json",
      serviceHost + "/kyc/address/get",
      data
    );
    return { response, err: null };
  } catch (err) {
    if (err) {
      return { response: null, err };
    }
  }
};

export const getFiles = async (id) => {
  let data = { clientId: id };
  try {
    let response = await ServiceRequest(
      "post",
      "json",
      serviceHost + "/kyc/addressfiles/get",
      data
    );
    return { response, err: null };
  } catch (err) {
    if (err) {
      return { response: null, err };
    }
  }
};

export const deleteAddress = async (id) => {
  try {
    let response = await ServiceRequest(
      "post",
      "json",
      serviceHost + "/kyc/address/delete",
      { id: id }
    );
    return { response, err: null };
  } catch (err) {
    if (err) {
      return { response: null, err };
    }
  }
};

export const saveAddress = async (data) => {
  try {
    let response = await ServiceRequest(
      "post",
      "json",
      serviceHost + "/kyc/address/save",
      data
    );
    return { response, err: null };
  } catch (err) {
    if (err) {
      return { response: null, err };
    }
  }
};

export const getAddressesForCSV = async (clientId) => {
  try {
    let response = await ServiceRequest(
      "post",
      "json",
      serviceHost + "/kyc/address/getAddressesForCSV/" + clientId
    );
    return { response, err: null };
  } catch (err) {
    if (err) {
      return { response: null, err };
    }
  }
};

export const getContacts = async (value, clientId) => {
  let body = {
    value: value,
    clientId: clientId,
  };
  try {
    let response = await ServiceRequest(
      "post",
      "json",
      serviceHost + "/kyc/address/getContactName",
      body
    );
    return { response, err: null };
  } catch (err) {
    if (err) {
      return { response: null, err };
    }
  }
};

export const getBankDet = async (value, clientId) => {
  let body = {
    value: value,
    clientId: clientId,
  };
  try {
    let response = await ServiceRequest(
      "post",
      "json",
      serviceHost + "/kyc/address/getBank",
      body
    );
    return { response, err: null };
  } catch (err) {
    if (err) {
      return { response: null, err };
    }
  }
};
